import {useEffect, useState} from 'react';
import {Button, Form, Input, Layout, message, DatePicker, Upload} from 'antd';
// import "antd/dist/antd.css";
import './index.css';
import MainMenu from "../../components/MainMenu/index.jsx";
import ProvaCandidatoService from "../../service/ProvaCandidatoService.js";
import {USER_NAME_SESSION_ATTRIBUTE_NAME} from "../../service/AuthenticationService.js";
import dayjs from 'dayjs';
import { UploadOutlined } from '@ant-design/icons';
import {useHistory} from "react-router-dom";
const {Content, Footer} = Layout;


function CadastrarProva() {

  const [nome, setNome] = useState('');
  const [cpf, setCpf] = useState('');
  const [numeroInscricao, setNumeroInscricao] = useState('');
  const [dataNascimento, setDataNascimento] = useState('13/02/2025');
  const [idCandidato, setIdCandidato] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [concurso, setConcurso] = useState(null);
  const [nomeConcurso, setNomeConcurso] = useState(null);
  const history = useHistory();
  let candidato;

  const [form] = Form.useForm();
  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];

  const candInsc = numeroInscricao;
  const nomeCon = nomeConcurso;
  const handleSubmit = event => {
    const fileSizeInBytes = fileList[0].size;
    const fileSizeInMegabytes = fileSizeInBytes / (1024 * 1024);

    if (fileSizeInMegabytes > 200) {
      message.error('O arquivo precisa ser menor que 200MB!');
    }else{
      const formData = new FormData();
      fileList.forEach((file) => {
        formData.append('arquivo', file);
      });
      setUploading(true);


      const nomeEnviado = nome;
      const cpfEnviado = cpf;
      const dataNascimentoEnviado = "2025-02-13";

      // ProvaCandidatoService.cadastrarProvaInscricaoConcluida(formData, cpfEnviado, candInsc)
      ProvaCandidatoService.cadastrarProva(formData, nomeEnviado, cpfEnviado, dataNascimentoEnviado, candInsc)
        .then(() => {
          message.success('Prova cadastrada com sucesso!');
          history.push('/home')
        })
        .catch((err) => {
          if (err.response.status === 409) {
            message.error('Prova já está cadastrada')
          } else if (err.response.status === 406){
            message.error('O envio não está disponível para este concurso')
          } else {
            message.error('Erro ao salvar, tente novamente mais tarde')
            console.log(err);
          }
        })
        .finally(() => {
          setUploading(false);
        });
    }
  }

  const validateMessages = {
    required: '${label} é obrigatório(a)!',
    // max: '${label} precisa ter no máximo',
    types: {
      number: '${label} is not a valid number!',
      email: '${label} não é um email válido!',
    },
  };

  const dadosJaCadastrados = () => {
    let nomeSalvo = "";
    nomeSalvo = nome;
    let cpfSalvo = "";
    cpfSalvo = cpf;
    let dataNascimentoSalvo = "";
    dataNascimentoSalvo = dataNascimento;
    if (nomeSalvo !== "" && cpfSalvo !== "" && dataNascimentoSalvo !== "") {
      return true;
    }
    return false;
  }

  const handleChangeDataNascimento = (date, dateString) => {
    console.log(date, dateString);
    setDataNascimento(dateString)
  };

  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  useEffect(() => {
    const user = sessionStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
    ProvaCandidatoService.getCandidatoData(user).then((response) => {
      form.setFieldsValue({
        nome: response.data.nome,
        cpf: response.data.cpf,
        dataNascimento: dayjs(response.data?.dataNascimento),
      });
      candidato = response.data;
      setNumeroInscricao(user);
      setDataNascimento(candidato?.dataNascimento)
      setNome(candidato.nome);
      setConcurso(candidato.idConcurso);
    }).catch((err) => {
      console.log(err);
    })

    // setIdCandidato(candidato.id);


    const c = concurso;
    if(c !== null){
      ProvaCandidatoService.getConcursoData(c).then((response) => {
        const {nome} = response.data;
        setNomeConcurso(nome)
      }).catch((err) => {
        console.log(err);
      })
    }
    // const jaCad = dadosJaCadastrados();
    // console.log("jaCad", jaCad)

  }, []);

  return (
    <div className="container">
      <Layout className="layout">
        <MainMenu active='2'></MainMenu>
        <Content style={{padding: '0 50px'}}>

          <div className="site-layout-content">
            <h2>Cadastrar heteroidentificação </h2>
            {/*<h4>Concurso: {nomeConcurso}</h4>*/}
            <h4>Número de inscrição: {candInsc}</h4>
            <Form style={{marginTop: '20px'}} onFinish={handleSubmit} form={form} name="cadastro-pessoa"
                  validateMessages={validateMessages} layout="horizontal"
                  labelCol={{
                    span: 4,
                  }}
            >
              <Form.Item
                name="nome" label="Nome"
                value={nome}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input
                  // disabled={nome !== ''}
                  style={{width: '50%'}} onChange={(e) => setNome(e.target.value)}/>
              </Form.Item>
              <Form.Item
                name="cpf" label="CPF"
                value={cpf}
                rules={[
                  {
                    required: true,
                    max: 11, message: 'O CPF precisa ter 11 números'
                  },
                ]}
              >
                <Input
                  // disabled={nome !== ''}
                  style={{width: '50%'}} onChange={(e) => setCpf(e.target.value)}/>
              </Form.Item>
              {/*<Form.Item*/}
              {/*  name="dataNascimento" label="Data de Nascimento"*/}
              {/*  value={dataNascimento}*/}
              {/*  rules={[*/}
              {/*    {*/}
              {/*      required: true,*/}
              {/*    },*/}
              {/*   ]}*/}
              {/* >*/}
              {/*  <DatePicker*/}
              {/*    // disabled={nome !== ''}*/}
              {/*    onChange={handleChangeDataNascimento}*/}
              {/* format={dateFormatList}*/}
              {/*   />*/}
              {/* </Form.Item>*/}
              <Upload maxCount={1} {...props}>
                <Button icon={<UploadOutlined />}>Selecionar arquivo</Button>
              </Upload>
              <Form.Item>
                <Button disabled={fileList.length === 0} loading={uploading} type="primary" htmlType="submit">
                  {uploading ? 'Enviando' : 'Enviar'}
                </Button>
              </Form.Item>
              <p style={{color: 'red'}}>Atenção:</p>
              <p>O cadastro da heteroidentificação só pode ser realizado uma única vez, ou seja, uma vez enviado o arquivo, o mesmo não pode ser alterado.</p>
              <p>Tamanho máximo do arquivo: 200mb</p>
              {/*{dadosJaCadastrados && <p style={{color: 'red'}}>Dados já cadastradados</p> }*/}
            </Form>
          </div>
        </Content>
        <Footer style={{textAlign: 'center'}}>IAUPE ©2025</Footer>
      </Layout>

    </div>
  );
}

export default CadastrarProva;